import { FeatureToggleService } from '@cemex-core/cmx-rollout-toggle-v1';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { Observable } from 'rxjs';
import { Features } from '@ordersnproducts/features';
import { map } from 'rxjs/operators';
import { ExperiencesService } from '@ordersnproducts/modules/shared/services/experiences.service';
import { SpecFieldNames } from '../../specification/constants/specification-field-names.enum';

export namespace UnloadTypeProvider {
  export class Disabled extends BaseAsyncValue<boolean> {
    getValue(): Observable<boolean> {
      const experiencesService: ExperiencesService = this.injector.get(ExperiencesService);
      const featureToggle: FeatureToggleService = this.injector.get(FeatureToggleService);
      const toggle = featureToggle.isFeatureEnabled(Features.PUMP_PRIMER);
      return experiencesService.commandDcoEnabled$().pipe(
        map((isCommand2) => {
          if (this.form) {
            const unloadTypeControl = this.form.get(SpecFieldNames.UNLOAD_TYPE);
            if (toggle && isCommand2) {
              unloadTypeControl?.enable();
              return false;
            } else {
              unloadTypeControl?.disable();
              return true;
            }
          } else {
            return false;
          }
        }),
      );
    }
  }
  export class Value extends BaseAsyncValue<string | null> {
    getValue(): Observable<string | null> {
      const experiencesService: ExperiencesService = this.injector.get(ExperiencesService);
      const featureToggle: FeatureToggleService = this.injector.get(FeatureToggleService);
      const toggle = featureToggle.isFeatureEnabled(Features.PUMP_PRIMER);
      return experiencesService.commandDcoEnabled$().pipe(
        map((isCommand2) => {
          if (toggle && isCommand2) {
            this.form.get(SpecFieldNames.UNLOAD_TYPE).setValue(undefined);
            return undefined;
          }
          this.form.get(SpecFieldNames.UNLOAD_TYPE).setValue('DIRECT_FLOW');
          return 'DIRECT_FLOW';
        }),
      );
    }
  }
}
